import { createClient, createConfig } from "@hey-api/client-fetch";

import { getEnv } from "../utils/env";

/**
 * Client for the refresh-cookie endpoints (/auth/refresh, /auth/logout,
 * MDRS-556). Points at the same backend as apiClient, but without its fetch
 * wrapper: that wrapper calls refreshAppTokenIfNeeded() when a request 401s,
 * so sending the refresh itself through it would recurse on a failed refresh.
 *
 * The generated default client can't be used instead: its baseUrl is the
 * hard-coded 'http://0.0.0.0:8000' from codegen.
 *
 * Its own module, not apiClient.ts: apiClient imports tokenManager, which
 * imports this.
 */
export const authClient = createClient(
  createConfig({
    baseUrl: getEnv("VITE_BACKEND_URL") || "http://localhost:8000",
    credentials: "include",
  })
);
